/**
 * Copyright 2023 ForgeRock AS. All Rights Reserved
 *
 * Use of this code requires a commercial software license with ForgeRock AS
 * or with one of its affiliates. All use shall be exclusively subject
 * to such license between the licensee and ForgeRock AS.
 */

import { useEsvInputStore } from '@forgerock/platform-shared/src/stores/esvInput';
import { formatIdAsPlaceholder } from '@forgerock/platform-shared/src/utils/esvUtils';
import { getStartupVariables, getStartupSecrets } from '@/api/EsvApi';

/**
 * Load ESV secrets and variables and save them to the store
 */
// eslint-disable-next-line import/prefer-default-export
export async function loadEsvInputData() {
  const esvInputStore = useEsvInputStore();
  try {
    const { data: { result: variables } } = await getStartupVariables();
    const { data: { result: secrets } } = await getStartupSecrets();

    esvInputStore.variables = variables
      .filter((variable) => variable.loaded === true)
      .map((variable) => ({
        id: variable._id,
        placeholder: formatIdAsPlaceholder(variable._id),
        expressionType: variable.expressionType,
      }));

    esvInputStore.secrets = secrets
      .filter((secret) => secret.loaded === true && secret.useInPlaceholders === true)
      .map((secret) => ({
        id: secret._id,
        placeholder: formatIdAsPlaceholder(secret._id),
      }));
  } catch {
    // Error retrieving API data, do nothing
  }
}
